import { render } from "./add_new_carrier.vue?vue&type=template&id=0b629e0c"
import script from "./add_new_carrier.vue?vue&type=script&lang=js"
export * from "./add_new_carrier.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__